import React from 'react';
import { observer } from 'mobx-react';
import { Typography } from '@material-ui/core';
import zIndex from '@material-ui/core/styles/zIndex';

import { useStore } from '../../store';
import { BackdropPanel, Icon } from '../../components';
import { MuiBackdropButton } from '../../components/BackdropPanel/style';
import { TranslationJSX } from '../../utils/Translation';

const DetailPanelError = () => {
    const {
        detailStore: {
            errorState: { status, errorCode },
            onResetErrorState,
        },
    } = useStore();

    if (!status && !errorCode) return null;

    const isNetworkError = status === 100 && errorCode && errorCode >= 90;
    const ErrorIcon = () => {
        if (isNetworkError) {
            return <Icon name="errorServer" size={80} />;
        }
        return <Icon name="errorLocal" size={80} />;
    };

    const ErrorMessage = () => {
        if (status === 1 && errorCode === 10) {
            // 저장공군 부족 1
            return <TranslationJSX locoKey="feed_download_storage_error_msg" />;
        }
        if (status === 21) {
            // phone 잠김 4
            return <TranslationJSX locoKey="feed_download_stopped_error_msg" />;
        }
        if (isNetworkError) {
            // 프로젝트 설치 오류(네트워크) 2-1
            return <TranslationJSX locoKey="feed_download_network_error_msg" />;
        }
        // 프로젝트 설치 오류(알수없는) 2-2
        return <TranslationJSX locoKey="feed_download_unknown_error_msg" />;
    };

    return (
        <BackdropPanel isOpen style={{ zIndex: zIndex.snackbar }}>
            <ErrorIcon />
            <Typography variant="body2">
                <ErrorMessage />
            </Typography>
            <MuiBackdropButton onClick={onResetErrorState}>
                <TranslationJSX locoKey="button_ok" />
            </MuiBackdropButton>
        </BackdropPanel>
    );
};

export default observer(DetailPanelError);
